/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratornofundsfound4Inputs */

const en_settings_collaborators_invitecollaboratornofundsfound4 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratornofundsfound4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Funds found`)
};

/**
* | output |
* | --- |
* | "No Funds found" |
*
* @param {Settings_Collaborators_Invitecollaboratornofundsfound4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratornofundsfound4 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratornofundsfound4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratornofundsfound4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratornofundsfound4(inputs)
});
export { settings_collaborators_invitecollaboratornofundsfound4 as "settings_collaborators_inviteCollaboratorNoFundsFound" }